import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import LocationApi from "../../api/location";
import useCallApi from "../../hooks/useCallApi";
import { Routes } from "../../routes/Routes";
import { useAlert } from "../../context/AlertContext";
import { useFormik } from "formik";
import location from "../../validations/location";
import { useContent } from "../../content/useContent";
import { useRTL } from "../../hooks/useLanguage/useRTL";

const useLocationContainer = (gameId: any, id?: any) => {
  const navigate = useNavigate();
  const { schema, pages, general } = useContent();
  const { locations } = pages;
  const { callApi, loading } = useCallApi();
  const { setSuccessMessage, setErrorMessage } = useAlert();
  const { isRTL } = useRTL();

  const [pageLoading, setPageLoading] = useState(true);

  const [initialValuesEvent, setInitialValuesEvent] = useState({
    longitude: 0,
    latitude: 0,
  });

  const [center, setCenter] = useState({ lat: 0, lng: 0 });
  const [zoom, setZoom] = useState(5);

  useEffect(() => {
    if (id) {
      setPageLoading(true);
      callApi(LocationApi.getOne(id), (location: any) => {
        setInitialValuesEvent({
          latitude: location.latitude,
          longitude: location.longitude,
        });
        setCenter({ lat: location.latitude, lng: location.longitude });
        setPageLoading(false);
      });
    } else {
      setPageLoading(false);
    }
  }, [id, isRTL]);

  const handleSubmit = (values: any) => {
    let body = { ...values };

    const successMessage = id
      ? locations.updateLocation
      : locations.createLocation;

    if (id) {
      callApi(LocationApi.update(id, body), () => {
        setTimeout(() => setSuccessMessage(successMessage), 1000);
        navigate(Routes.getGame(gameId));
      });
    } else {
      callApi(LocationApi.create(gameId, body), (result: any) => {
        setTimeout(() => setSuccessMessage(successMessage), 1000);
        navigate(Routes.getGame(gameId));
      });
    }
  };

  const formik: any = useFormik({
    enableReinitialize: true,
    initialValues: initialValuesEvent,
    validationSchema: () => location(schema),
    onSubmit: (values: any) => handleSubmit(values),
  });

  const handleMarker = (e: any) => {
    formik.setFieldValue("latitude", e.latLng.lat());
    formik.setFieldValue("longitude", e.latLng.lng());
  };

  const handleSearch = (lat: any, lng: any) => {
    formik.setFieldValue("latitude", lat);
    formik.setFieldValue("longitude", lng);
  };

  return {
    pageLoading,
    formik,
    center,
    handleMarker,
    handleSearch,
    setCenter,
    zoom,
    setZoom,

    loading,
  };
};

export default useLocationContainer;
